const APP_URL = process.env.APP_URL || 'http://localhost:3000'

const bedsider = window.bedsider || {}

// Please update the public documention in /tools/index.haml
// eslint-disable-next-line func-names
bedsider.methodExplorer = function (placeholderSelector, styleInit = null) {
  const placeholder = document.querySelector(placeholderSelector)
  if (!placeholder) {
    console.warn(
      `method_explorer: Could not find a placeholder element for "${placeholderSelector}`,
      '"'
    )
    return
  }

  const style =
    styleInit || 'width: 1px; min-width: 100%; border: none; background: #fff;'

  const iframe =
    '<iframe id="bedsider_method_explorer_container"' +
    ` src="${APP_URL}/tools/methods"` +
    ` style="${style}"` +
    ' sandbox="allow-scripts allow-popups"' +
    ' height="1200"' +
    ' />'
  placeholder.insertAdjacentHTML('afterbegin', iframe)
}
